import React from 'react';
import { AdvertorialButton } from '../ui/AdvertorialButton';
export function FooterSection() {
  const trustBadges = [{
    icon: '✓',
    text: 'Third-Party Tested'
  }, {
    icon: '🛡️',
    text: '90-Day Guarantee'
  }, {
    icon: '📍',
    text: 'Australian Delivery'
  }];
  const legalLinks = ['Privacy Policy', 'Terms & Conditions', 'Disclaimer'];
  const supportInfo = ['Email: support@qshield.com.au', 'Phone: 1800-QSHIELD', 'Hours: Mon-Fri 9AM-5PM AEDT'];
  return <>
      {/* Secondary CTA Section */}
      <section className="w-full py-14 px-4 md:px-6 text-center border-t-2" style={{
      background: 'linear-gradient(135deg, #1B4F9E 0%, #2E5FBE 100%)',
      borderColor: '#2D9B6E',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }} data-id="element-14">
        <p className="text-lg md:text-xl font-semibold text-white mb-7" data-id="element-15">
          Ready to protect your family?
        </p>

        <AdvertorialButton variant="secondary" data-id="element-16">
          START YOUR 90-DAY TRIAL
        </AdvertorialButton>

        <p className="mt-3 text-sm" style={{
        color: 'rgba(255, 255, 255, 0.95)'
      }} data-id="element-17">
          Full refund if not satisfied. No questions asked.
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 mt-10" data-id="element-18">
          {trustBadges.map((badge, index) => <div key={index} className="flex items-center gap-2" data-id="element-19">
              <span style={{
            color: '#2D9B6E'
          }} data-id="element-20">
                {badge.icon}
              </span>
              <span className="text-xs font-semibold" style={{
            color: 'rgba(255, 255, 255, 0.9)'
          }} data-id="element-21">
                {badge.text}
              </span>
            </div>)}
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-10 px-4 md:px-6" style={{
      backgroundColor: '#2C3E50',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }} data-id="element-22">
        <div className="max-w-6xl mx-auto" data-id="element-23">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-24">
            {/* Company Info */}
            <div data-id="element-25">
              <div className="text-lg font-bold text-white" data-id="element-26">QShield</div>
              <div className="text-xs mt-2" style={{
              color: 'rgba(255, 255, 255, 0.7)'
            }} data-id="element-27">
                EMF Protection for Modern Families
              </div>
            </div>

            {/* Legal Links */}
            <div data-id="element-28">
              <div className="text-sm font-semibold text-white mb-3" data-id="element-29">Legal</div>
              <div className="space-y-2" data-id="element-30">
                {legalLinks.map((link, index) => <a key={index} href="#" className="block text-xs transition-colors duration-200 hover:text-white" style={{
                color: 'rgba(255, 255, 255, 0.7)'
              }} data-id="element-31">
                    {link}
                  </a>)}
              </div>
            </div>

            {/* Support */}
            <div data-id="element-32">
              <div className="text-sm font-semibold text-white mb-3" data-id="element-33">
                Support
              </div>
              <div className="space-y-2" data-id="element-34">
                {supportInfo.map((info, index) => <div key={index} className="text-xs" style={{
                color: 'rgba(255, 255, 255, 0.7)',
                lineHeight: '1.8'
              }} data-id="element-35">
                    {info}
                  </div>)}
              </div>
            </div>

            {/* Social */}
            <div data-id="element-36">
              <div className="text-sm font-semibold text-white mb-3" data-id="element-37">
                Follow Us
              </div>
              <div className="flex gap-4" data-id="element-38">
                {['Facebook', 'Instagram', 'LinkedIn'].map((social, index) => <a key={index} href="#" className="text-xs transition-colors duration-200 hover:text-white" style={{
                color: 'rgba(255, 255, 255, 0.7)'
              }} data-id="element-39">
                    {social}
                  </a>)}
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-4 border-t text-center text-xs" style={{
          borderColor: 'rgba(255, 255, 255, 0.2)',
          color: 'rgba(255, 255, 255, 0.5)'
        }} data-id="element-40">
            © 2025 QShield EMF Protection. All rights reserved. | ABN: [INSERT]
            | Disclaimer: This advertorial is for informational purposes only
            and should not be taken as medical advice.
          </div>
        </div>
      </footer>
    </>;
}